/**
 * 功能：Loading窗口
 * 参数：
 *  loading:
 *  {
 *    showLoading: 显示Loading窗口（默认：true)
 *    target: 挂载DOM对象（默认：body）
 *    text: string，文本（默认：【无】）
 *    icon: string，图标（默认：el-icon-loading）
 *    background: 背景颜色
 *  }
 */
import _ from 'lodash'
import { Loading } from 'element-ui'

// Loading窗口
let loadingWindow = null
// 当前正在Loading的请求数量
let loadingRequestCount = 0
// Loading窗口延迟关闭时间（单位：毫秒）
const loadingWindowDelayCloseTIme = 300

// 显示loading
export function showLoading (config = null) {
  // 获取参数
  const show = config && config.showLoading != undefined ? config.showLoading : true
  const target = config && config.target != undefined ? config.target : 'body'
  const text = config && config.text != undefined ? config.text : ''
  let icon = config && config.icon != undefined ? config.icon : 'el-icon-loading'
  const background = config && config.background != undefined ? config.background : 'rgba(0,0,0,0.2)'
  // 处理非Element-UI图标（IconFont）
  if (icon.trim().substring(0, 2) != 'el') { icon = 'loading-iconfont ' + icon }
  // 无须显示Loading窗口
  if (show == false) return
  // Loading窗口已经打开
  if (loadingRequestCount++ > 0) return
  // 打开Loading窗口（不同页面调用Loading.service的fullscreen模式会产生不同的Loading实例）
  if (loadingWindow) return
  loadingWindow = Loading.service(
    {
      fullscreen: true,
      lock: true,
      target: target,
      text: text,
      background: background,
      spinner: icon,
      customClass: 'loading-window'
    })
}

// 隐藏loading
export function hideLoading () {
  // 计算当前正在Loading的请求数量
  if (--loadingRequestCount < 0) { loadingRequestCount = 0 }
  // 当前还存在需要显示Loading窗口的请求
  if (loadingRequestCount > 0) return
  // 延迟关闭Loading窗口
  const debounceCloseLoadingWindow = _.debounce(closeLoadingWindow, loadingWindowDelayCloseTIme)
  debounceCloseLoadingWindow()
}

function closeLoadingWindow () {
  // 当前还存在需要显示Loading窗口的请求
  if (loadingRequestCount > 0) return
  // 关闭Loading窗口
  loadingWindow && loadingWindow.close()
  loadingWindow = null
}



// WEBPACK FOOTER //
// ./src/utils/request/loading.js